const NotFoundPage = () => {
    return (
      <>
        <p>Not found page</p>
      </>
    );
};

export default NotFoundPage;